import Analytics from "./tracker/Analytics4";
import GTag from "./tracker/GoogleTagManager";
import MetaEvents from "./tracker/MetaEventTracking";

let region;
let obj;
let serviceConsentObjs;
let cmpData;

export default class Tracking {

    constructor() {
        if(window.aboshop.region) {
           region = window.aboshop.region;
        }
        obj = this;
        this.run();
        
    }
    
    async run() {
        const analytics = new Analytics();
        const gtag = new GTag();
        const metaEvents = new MetaEvents();

        serviceConsentObjs = [analytics, gtag];
        this.#isCmpObjSet().then(() => {
            // window.__cmp("addEventListener",["settings",() => {
            //     serviceConsentObjs.forEach( (item) => {
            //         cmpData = window.__cmp('getCMPData');
            //         obj.checkServiceConsent(item.getCmtId(), item);
            //     });
            // },false],null);

             window.__cmp("addEventListener",["consent",() => {
                serviceConsentObjs.forEach( (item) => {
                    cmpData = window.__cmp('getCMPData');
                    obj.checkServiceConsent(item.getCmtId(), item);
                });
            },false],null);
        });
    }



     async checkServiceConsent(serviceId, service) {
            let cmpData = window.__cmp('getCMPData');
            if(cmpData.vendorConsents[serviceId]) {
                service.load();
            } else {
              service.destroy();
            }
    }

     #isCmpObjSet() {
        let oldSchoolWaiterCount = 0;
        return new Promise( (resolve, reject) => {
          if(window.__cmp != undefined) {
            resolve();
          } else {
            const oldSchoolWaiter = setInterval(function () {
                console.log('oldSchoolWaiter', oldSchoolWaiter);
              if (typeof __tcfapi !== "undefined") {
                resolve();
                clearInterval(oldSchoolWaiter)
              } else if (oldSchoolWaiterCount > 10) {
                clearInterval(oldSchoolWaiter);
                 reject('Timeout erreicht');
              } else {
                oldSchoolWaiterCount++
              }
            }, 500);
          }
        })
  }

}